module.exports = __webpack_public_path__ + "img/promo-bg.1d2d9af.jpg";